import { Navbar } from "@/components/landing/Navbar";
import { HeroGeometric } from "@/components/landing/HeroGeometric";
import { Features } from "@/components/landing/Features";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Pricing } from "@/components/landing/Pricing";
import { Footer } from "@/components/landing/Footer";

export function Home() {
  return (
    <div className="min-h-screen bg-[#030303] text-white">
      <Navbar />
      <main>
        <HeroGeometric />
        <Features />
        <HowItWorks />
        <Pricing />
      </main>
      <Footer />
    </div>
  );
}
